export const USER_TYPE_COOKIE_NAME = `USER_TYPE`;
export const VERIFYING_TOKEN_COOKIE_NAME = `VERIFYING_TOKEN`;
export const REFRESH_TOKEN_COOKIE_NAME = `REFRESH_TOKEN`;
export const ACCESS_TOKEN_COOKIE_NAME = `ACCESS_TOKEN`;
export const IS_LOGGED_IN_COOKIE_NAME = `LOGGED_IN`;
export const REFRESH_TOKEN_EXPIRE_TIME_MS = 604800000; // 7 days
